import type { SsoStatus } from "../../types/Sso";
import type { SsoStatusDto } from "../../services/ApiService";
import { isNil } from "lodash-es";

const resolveState = (dto: SsoStatusDto) => {
  if (isNil(dto.sso) || isNil(dto.dsync)) {
    return "unconfigured";
  } else if (dto.sso?.state === "active" && dto.dsync?.state === "active") {
    return "active";
  } else {
    return "inactive";
  }
};

export const toSsoStatus = (dto: SsoStatusDto): SsoStatus => ({
  state: resolveState(dto),
  sso: {
    state: isNil(dto.sso) ? "unconfigured" : dto.sso.state,
  },
  dsync: {
    state: isNil(dto.dsync) ? "unconfigured" : dto.dsync.state,
  },
  provisioned: dto.provisioned,
  shared: dto.shared,
});
